"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_ClaimResponse_Payment = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Money_1 = require("./RTTI_Money");
var RTTI_date_1 = require("../Scalar/RTTI_date");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
exports.RTTI_ClaimResponse_Payment = t.recursion('IClaimResponse_Payment', function () {
    return t.intersection([
        t.type({
            type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            amount: RTTI_Money_1.RTTI_Money
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            adjustment: RTTI_Money_1.RTTI_Money,
            adjustmentReason: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            date: RTTI_date_1.RTTI_date,
            _date: RTTI_Element_1.RTTI_Element,
            identifier: RTTI_Identifier_1.RTTI_Identifier
        })
    ]);
});
//# sourceMappingURL=RTTI_ClaimResponse_Payment.js.map